import actions from "./actions.js";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state() {
    return {
      employees: [],
      lastFetch:null
    };
  },
  mutations,
  actions,
  getters,
};
